var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline_General_Chart-pie-alt",
    "data-name": "Outline / General / Chart-pie-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .inactiveAsset {\r\n        fill: #8c8d99;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chart-pie-alt",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "inactiveAsset",
    d: "M8.75,17.5A8.75,8.75,0,0,1,8.75,0,.751.751,0,0,1,9.5.75V8h7.25a.751.751,0,0,1,.75.75A8.76,8.76,0,0,1,8.75,17.5ZM8,1.538A7.25,7.25,0,1,0,15.962,9.5H8.75A.751.751,0,0,1,8,8.75V1.538Z",
    transform: "translate(0.25 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "inactiveAsset",
    d: "M7,7.945H.5a.5.5,0,0,1-.5-.5V.945A.919.919,0,0,1,.889,0,.885.885,0,0,1,1,.007,8.022,8.022,0,0,1,5.657,2.288,8.021,8.021,0,0,1,7.938,6.947a.85.85,0,0,1-.21.676A.968.968,0,0,1,7,7.945ZM1.5,1.619V6.445H6.326A6.538,6.538,0,0,0,1.5,1.619Z",
    transform: "translate(11 0.055)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveAssets);
export default __webpack_public_path__ + "static/media/inactive-assets.47a49a9c44814bfb37eda662111db546.svg";
export { ForwardRef as ReactComponent };